import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="bg-pearl-50 py-16 dark:bg-slate-950 sm:py-20" aria-labelledby="faq-heading" data-id="element-62" data-mp="1lc1yr8r0kvp2">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-63" data-mp="1gal2xrndzzfc">
        <div data-id="element-64" data-mp="2dy3hxk7n5xrs">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-plum-500 dark:text-plum-300" data-id="element-65" data-mp="291mjnx6qa30z">
            FAQ
          </p>
          <h2 id="faq-heading" className="mt-3 font-display text-3xl font-semibold tracking-tight text-slate-900 dark:text-pearl-50 sm:text-4xl" data-id="element-66" data-mp="240yulh227w9e">
            Frequent questions
          </h2>
        </div>

        <ul className="divide-y divide-slate-200 border-y border-slate-200 dark:divide-slate-800 dark:border-slate-800" data-id="element-67" data-mp="snwdmkw1t4op">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <li key={faq.question} data-id="element-68" data-mp="pih9wa4fndv9" data-mpi={i}>
                <h3 data-id="element-69" data-mp="uh0v28b7clmk">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors hover:text-plum-500 dark:hover:text-plum-300" data-id="element-70" data-mp="uhkejtgi3i2p">
                    <span className="font-display text-lg font-semibold text-slate-900 dark:text-pearl-50" data-id="element-71" data-mp="6rg9dhnnza9l">
                      {faq.question}
                    </span>
                    <PlusIcon className={`mt-1 h-5 w-5 flex-none text-slate-500 transition-transform duration-300 dark:text-slate-400 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-72" data-mp="bk9g2b2p0sob" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-73" data-mp="3jy8cfdtkug2c">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-74" data-mp="3jyrr8lnxkoc5">
                      <p className="pb-5 pr-10 leading-relaxed text-slate-600 dark:text-slate-300" data-id="element-75" data-mp="1fs89o1aatw2i">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}